'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var Details = require('./components/Details.js');
var PrefetchData = require('./components/PrefetchData.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);

const DriverDetails = ({
  featureName,
  layout = nthKitDynamicLayoutNext.LayoutTree.FeatureLayout.LANDSCAPE
}) => {
  const {
    panelcontainerNoneNone: containerStyle
  } = nthHookTheme.useTheme();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    if (!currentShipment) return;
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DRIVER_DETAILS
    });
  }, [featureName, logEvent, currentShipment]);
  if (!currentShipment) return null;
  const {
    status,
    statusCode,
    vehicle
  } = currentShipment;
  if (!vehicle || typeof statusCode !== 'string' || typeof status !== 'string') {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: containerStyle
  }, /*#__PURE__*/React__default["default"].createElement(Details["default"], _extends__default["default"]({
    featureName: featureName,
    status: status,
    layout: layout,
    translations: {
      status,
      category: statusCode
    }
  }, vehicle)));
};
const DriverDetailsWithData = nthHookTheme.withThemeProvider(DriverDetails, {
  themeTokens: ['spinnerPrimaryNone', 'panelcontainerNoneNone']
});
const DriverDetailsWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(DriverDetailsWithData, _extends__default["default"]({
  featureName: featureName
}, props)));
DriverDetailsWithPrefetchedData.propTypes = DriverDetailsWithData.propTypes;

exports["default"] = DriverDetailsWithPrefetchedData;
